var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { mq, styled } from "../../utils";
import Text from "../Text";
import Icon from "../Icon";
import { useToast, useWindowSize } from "../../hooks";
import ScreenRotation from "./ScreenRotation";
import Footer from "./Footer";
import trimCanvas from "./trimCanvas";
import { isMobile } from 'react-device-detect';
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(243, 243, 243, 0.97);\n  z-index: 1000;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(243, 243, 243, 0.97);\n  z-index: 1000;\n"])));
var Flex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 90%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"], ["\n  height: 90%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"])));
var StyledCloseIcon = styled(Icon.Close)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 1.5rem;\n  height: 1.5rem;\n  position: absolute;\n  cursor: pointer;\n  z-index: 9;\n\n  ", ";\n"], ["\n  width: 1.5rem;\n  height: 1.5rem;\n  position: absolute;\n  cursor: pointer;\n  z-index: 9;\n\n  ",
    ";\n"])), mq({
    top: ['20px', '30px'],
    right: ['30px', '40px'],
}));
var StyledText = styled(Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  ", ";\n"], ["\n  position: absolute;\n  ",
    ";\n"])), mq({
    top: ['40px', '50px'],
    left: ['30px', '40px'],
}));
var SignaturePad = function (_a) {
    var onClose = _a.onClose, save = _a.save, _b = _a.trim, trim = _b === void 0 ? false : _b, labels = _a.labels;
    var signCanvas = useRef(null);
    var windowSize = useWindowSize();
    var portrait = windowSize.width < windowSize.height;
    var addToast = useToast().addToast;
    useEffect(function () {
        if (!portrait && !!signCanvas.current) {
            var canvas = signCanvas.current.getCanvas();
            canvas.scrollTo(0, canvas.scrollHeight);
        }
    }, [portrait]);
    var handleSubmit = function () {
        if (signCanvas.current && !signCanvas.current.isEmpty()) {
            var canvas = trim
                ? trimCanvas(signCanvas.current.getCanvas())
                : signCanvas.current.getCanvas();
            var ctx = canvas.getContext('2d');
            ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = 'rgba(255, 255, 255, 1)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            save(canvas.toDataURL());
            onClose();
        }
        else {
            addToast(labels.signatureEmptyValidator, 'error');
        }
    };
    var handleRetry = function () {
        if (signCanvas.current) {
            signCanvas.current.clear();
        }
    };
    return (React.createElement(Overlay, null,
        React.createElement(StyledText, null,
            labels.writeAboveLine,
            " "),
        portrait && React.createElement(ScreenRotation, { label: labels.screenRotation }),
        React.createElement(StyledCloseIcon, { onClick: onClose }),
        React.createElement(Flex, null,
            React.createElement(SignatureCanvas, { ref: signCanvas, clearOnResize: isMobile, canvasProps: {
                    style: {
                        borderBottom: '5px solid black',
                        width: '80%',
                        height: '70%',
                    },
                } })),
        React.createElement(Footer, { labels: labels.footer, onCancel: onClose, onSubmit: handleSubmit, retry: handleRetry })));
};
export default SignaturePad;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map